import { BitmapBehavior, MeterBehavior } from "@quest/murka-games-behavior-panther";
import { Container } from "@quest/pixi-bridge";
import { dispatcher, IEvent, ingenuity, IObject, ITween, Linear } from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";
import { View } from "./View";

export class FgQLinePlayerMessageController {
    private view: View;

    private qLinesPlayerMessageContainer: Container;
    private playerMessageWinContainer: Container;
    private playerMessageSymbolContainer: Container;

    private symbolCountMeter: MeterBehavior;
    private playerMessageWinMeter: MeterBehavior;

    private playerMessageBase: BitmapBehavior;
    private playerMessagePays: BitmapBehavior;

    private symbolAmount: number = 0;
    private symbolId: number = 0;
    private symbolCount: number = 0;
    private symbolImages = ['wild.png', 'character_1x1.png', 'jeep.png', 'train.png', 'airship.png', 'camera.png', 'pocket_watch.png', 'bullets.png', 'scotch_glass_symbol.png', 'cigarette_case_symbol.png', 'hat.png', 'note.png', 'magnifying_glass.png', 'key.png', 'spotlight.png']
    /**
     * Class constructure.
     */
    constructor(freeGameView: View) {
        this.view = freeGameView;
        this.init();
    }

    /**
     * Constructor method to run class funcationalities.
     */
    private init(): void {
        this.initializeElementes();
        this.subscribeEvents();
    }

    /**
     * Method to initialize UI elements.
     */
    private initializeElementes(): void {
        this.qLinesPlayerMessageContainer = this.view.getContainerByID("qLinesPlayerMessageContainer");
        this.playerMessageWinContainer = this.view.getContainerByID("playerMessageWinContainer");
        this.playerMessageSymbolContainer = this.view.getContainerByID("playerMessageSymbolContainer");

        this.playerMessageBase = this.view.getImageById("playerMessageBase") as BitmapBehavior;
        this.playerMessagePays = this.view.getImageById("playerMessagePays") as BitmapBehavior;

        this.symbolCountMeter = this.view.getMeterById("symbolCountMeter") as MeterBehavior;
        this.playerMessageWinMeter = this.view.getMeterById("playerMessageWinMeter") as MeterBehavior;
    }

    /**
     * Method to subscribe events.
     */
    private subscribeEvents(): void {
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.FG_SHOW_QL_PLAYER_MESSAGE, this.showPlayerMessages, this)
        dispatcher.on(eventDispatchers.FG_FORCE_STOP_QL_PLAYER_MESSAGE, this.forceStopPlayerMessage, this)
    }

    /**
     * Method to un-subscribe events.
    */
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.FG_SHOW_QL_PLAYER_MESSAGE, this.showPlayerMessages, this)
        dispatcher.off(eventDispatchers.FG_FORCE_STOP_QL_PLAYER_MESSAGE, this.forceStopPlayerMessage, this)
    }

    /**
      * Method to initiate player message.
      * @param evt 
      */
    private showPlayerMessages(evt?: IEvent): void {
        this.resetSymbolForToggle();
        this.addViewToTop();
        this.updateMessage();
        this.setVisibility();
        this.setAlignment();
        this.showBaseWithFadeIn();
    }

    private resetSymbolForToggle(): void {
        this.playerMessageSymbolContainer.removeChildren();
    }


    /**
     * Method to add player message view to top on view to avoid animation playing over player messages.
     */
    private addViewToTop(): void {
        this.view.addChild(this.qLinesPlayerMessageContainer);
    }

    /**
     * Method to set player messages view visibility true
     */
    private setVisibility(): void {
        this.playerMessageWinContainer.visible = true;
        this.symbolCountMeter.visible = true;
        this.playerMessageWinMeter.visible = true;
        this.playerMessageSymbolContainer.visible = true;
        this.playerMessagePays.visible = true;
        this.playerMessageBase.visible = true;
        let json = this.view.json.playerMessageSymbolWild_1x1;
        json.visible = true;
        json.frames = this.symbolImages[this.symbolId];
        let symbol = this.view.createImage(json);
        this.playerMessageSymbolContainer.addChild(symbol);
    }

    /**
     * Method to reset player messages view visibility false.
     */
    private resetVisibility(): void {
        this.playerMessageWinContainer.visible = false;
        this.symbolCountMeter.visible = false;
        this.playerMessageWinMeter.visible = false;
        this.playerMessageSymbolContainer.visible = false;
        this.playerMessagePays.visible = false;
        this.playerMessageBase.visible = false;
        this.playerMessageSymbolContainer.removeChildren();
    }

    /**
     * Method to set player message container pivot to center.
     */
    private setAlignment(): void {
        this.playerMessageWinContainer.setPivot(this.playerMessageWinContainer.width / 2, 0);
        if (this.symbolId === 1) {
            this.playerMessageWinContainer.x = (this.playerMessageWinContainer as any).json.charX;
        } else {
            this.playerMessageWinContainer.x = this.playerMessageWinContainer.json.x;

        }
    }

    /**
     * Method to update the playewr message win data as per current cascade played.
     */
    private updateMessage(): void {
        const winData: IObject = (ingenuity.parserModel as GameParserModel).getWinLinesData()[(ingenuity.parserModel as platformModel).getWinLinesData().length -
            (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()]

        this.symbolAmount = winData.win;
        this.symbolCount = winData.winSymLen;
        this.symbolId = winData.no;

        this.symbolCountMeter.setValue(this.symbolCount);
        this.playerMessageWinMeter.setCurrencyFormattedValue(this.symbolAmount);

    }

    /**
     * Method to show player message main container with fade in tween.
     */
    private showBaseWithFadeIn(): void {
        this.qLinesPlayerMessageContainer.alpha = 0;
        this.qLinesPlayerMessageContainer.visible = true;

        const baseZoomInTween: ITween = ingenuity.currentGame.add.tween(this.qLinesPlayerMessageContainer).to({ alpha: 1 }, 600, Linear.None, true, 0, 0, false);
        baseZoomInTween.onComplete.addOnce(() => {

            baseZoomInTween.stop();
            ingenuity.currentGame.tweens.remove(baseZoomInTween);
        }, this)
    }

    /**
     * Method to hide player message main container with fade out tween.
     */
    private showBaseWithFadeOut(): void {
        const baseZoomOutTween: ITween = ingenuity.currentGame.add.tween(this.qLinesPlayerMessageContainer).to({ alpha: 0 }, 600, Linear.None, true, 0, 0, false);
        baseZoomOutTween.onComplete.addOnce(() => {
            this.qLinesPlayerMessageContainer.visible = false;
            this.qLinesPlayerMessageContainer.alpha = 1;
            this.resetVisibility();
            baseZoomOutTween.stop();
            ingenuity.currentGame.tweens.remove(baseZoomOutTween);
        }, this)
    }

    /**
     * Method to force Hide player message main container
     */
    private forceStopPlayerMessage(): void {
        this.showBaseWithFadeOut();
    }
}